@if (loaderService.isLoading | async) {
  <div class="overlay">
    <mat-progress-bar mode="indeterminate"  style="height:3px"></mat-progress-bar>
  </div>
}